export * from './seomodule.component'
